<template>
  <div class="apply-for-service">
    <re-dialog title="申请服务" :visible.sync="show">
      <div class="p30">
        <el-form label-width="100px" ref="serviceApply" :rules="rules" :model="submit_form" style="width: 100%;">
          <el-form-item label="服务地址:" prop="address_id">
            <el-select v-model="submit_form.address_id" placeholder="请选择">
              <el-option
                  v-for="item in addressList"
                  :key="item.address_id"
                  :label="item.address"
                  :value="item.address_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="服务类型:" prop="type_id">
            <el-select
                v-model="submit_form.type_id"
                placeholder="请选择"
            >
              <el-option
                  v-for="item in serviceTypesList"
                  :key="item.type_id"
                  :label="item.type_name"
                  :value="item.type_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="服务人员:" prop="level_id">
            <el-select
                v-model="submit_form.level_id"
                placeholder="请选择"
            >
              <el-option
                  v-for="item in serviceLevelsList"
                  :key="item.level_id"
                  :label="item.level_name"
                  :value="item.level_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="服务时间:" prop="service_time">
            <el-date-picker
                v-model="submit_form.service_time"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发票信息:">
            <el-select
                v-model="submit_form.invoice_id"
                clearable
                placeholder="请选择"
            >
              <el-option
                  v-for="item in invoiceList"
                  :key="item.invoice_id"
                  :label="item.invoice_name"
                  :value="item.invoice_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input type="textarea" v-model="submit_form.order_remark" resize="none" :rows="6"></el-input>
          </el-form-item>

          <el-form-item label="备注图片">
            <upload-img :file_list.sync="submit_form.order_imgs"/>
          </el-form-item>
          <el-form-item>
            <div class="fr ac">
              <p>共{{ companyIntegral }}积分，本次使用</p>
              <select name="select" v-model="selectValue" @change="selectIntegral">
                <option :value="i.value" v-for="i in selectList" :key="i.value">{{ i.title }}</option>
              </select>
              <input v-show="selectValue === 'custom'" v-model.number="integral" :min="1" class="integral-input"
                     :max="maxIntegral" type="number"
                     @input="integralChange"/>
              抵扣<span class="red">￥{{ toDecimal2(integral / integral_ratio) || 0 }}</span>
            </div>
          </el-form-item>

          <el-form-item>
            <span v-show="!is_Empty(price)">预估价格:<span class="ml10">¥{{ price }}</span></span>
            <span v-show="!is_Empty(km)" class="ml20">距离:<span class="blue ml10">{{
                km
              }}KM</span></span>
          </el-form-item>


        </el-form>
      </div>
      <div class="fr ac jc" slot="footer">
        <el-button size="small" type="primary" @click="paramsInit(1)">申请服务</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>
export default {
  name: "applyForService",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectList: [],
      selectValue: 0,
      show: this.$props.value,
      rules: {
        name: [
          {required: true, message: '请选择客户', trigger: 'blur'},
        ],
        address_id: [
          {required: true, message: '请选择服务地址', trigger: 'blur'},
        ],
        type_id: [
          {required: true, message: '请选择服务类型', trigger: 'blur'},
        ],
        level_id: [
          {required: true, message: '请选择服务人员', trigger: 'blur'},
        ],
        service_time: [
          {required: true, message: '请选择服务时间', trigger: 'blur'},
        ],
      },
      integral: 0,
      submit_form: {
        name: "",
        address_id: "",
        type_id: "",
        level_id: "",
        invoice_id: "",
        order_remark: "",
        service_time: []
      },
      price: "",
      km: "",
      integral_ratio: "",
      companyIntegral: 0,
      serviceTypesList: [],
      serviceLevelsList: [],
      addressList: [],
      invoiceList: [],
    }
  },
  watch: {
    value(n) {
      this.show = n;
      n && this.init();
    },
    show(n) {
      this.$emit('input', n);
    },
    price(n) {
      this.orderActualPriceChange();
    },
    'submit_form.type_id'(n) {
      this.paramsInit();
    },
    'submit_form.level_id'(n) {
      this.paramsInit();
    },
    'submit_form.address_id'(n) {
      this.paramsInit();
    },
    integral(n) {
      this.paramsInit();
    }
  },
  computed: {
    maxIntegral() {
      let companyIntegral = Number(this.companyIntegral)
      let orderActualPrice = Number(this.price)
      let totalIntegral = companyIntegral / this.integral_ratio;
      if (orderActualPrice > totalIntegral) return companyIntegral;
      return orderActualPrice * this.integral_ratio;
    }
  },
  methods: {
    integralChange(e) {
      if (this.maxIntegral < this.integral) {
        this.integral = this.maxIntegral;
      }
    },
    selectIntegral() {
      this.integral = 0;
      let item = this.selectList.find(el => {
        return el.value === this.selectValue;
      })
      this.integral = isNaN(Number(item.value)) ? 0 : Number(item.value);

    },
    async init() {
      let res = (await this.post("companyInterfaces/v1.0/getCompanyDetail", {})).data
      if (!this.is_Empty(res)) {
        this.companyIntegral = Number(res.company_integral) || 0;
      }

      this.getServiceTypes();
      this.getServiceLevels();
      this.getMemberAddress();
      this.getInvoices();
    },
    async orderActualPriceChange() {
      //积分抵扣比例
      let res = await this.post("app/systemConfig/config/integral_ratio", {});
      let integral_ratio = res.data;
      let companyIntegral = this.companyIntegral;
      this.integral_ratio = integral_ratio;

      let selectList = [];
      selectList.push({
        title: "暂不使用",
        value: 0
      })
      let orderActualPrice = Number(this.price)
      if ((orderActualPrice - companyIntegral / integral_ratio) > 0) {
        selectList.push({
          title: `${this.companyIntegral}积分`,
          value: companyIntegral
        })
      }
      let presetPoints = [10, 5];
      presetPoints.forEach(el => {
        let integral = el * integral_ratio;
        if ((orderActualPrice - el) > 0 && integral < companyIntegral) {
          selectList.push({
            title: `${integral}积分`,
            value: integral
          })
        }
      })
      selectList.push({
        title: `自定义积分`,
        value: 'custom'
      })

      this.selectList = selectList;
    },
    paramsInit(type) {
      let obj = {
        ...this.submit_form,
        order_imgs: this.arrToStr(this.submit_form.order_imgs),
        integral: this.integral || 0,
      }

      if (this.is_Empty(obj.type_id) || this.is_Empty(obj.level_id) || this.is_Empty(obj.address_id)) {
        return;
      }

      let item = this.addressList.find(el => {
        return el.address_id == obj.address_id
      })


      obj.company_province = item.address_province
      obj.company_city = item.address_city
      obj.company_country = item.address_country
      obj.company_address = item.address_detailed;
      obj.service_start_time = this.submit_form.service_time[0] || "";
      obj.service_end_time = this.submit_form.service_time[1] || "";

      delete obj.service_time;


      if (this.is_Empty(type)) {
        this.checkout(obj);
      } else {
        this.submit(obj);
      }
    },
    checkout(obj) {

      this.post("serviceInterfaces/v1.0/checkout", obj).then((res) => {
        this.km = res.data.order_distance;
        this.price = res.data.order_actual_price;
      });
    },
    // 提交订单
    submit(obj) {
      this.$refs.serviceApply.validate((valid) => {
        if (valid) {
          if (this.$route.query.id) {
            obj.goods_order_id = this.$route.query.id;
          }
          this.post("serviceInterfaces/v1.0/insertServiceOrder", obj).then(
              (res) => {
                this.$message({
                  message: "服务已申请,请等待审核",
                  type: "success",
                });
                this.show = false;
                this.$emit('success')
              }
          );
        } else {
          console.log('error submit!!');
          return false;
        }
      });


    },


//获取客户地址列表
    getMemberAddress() {
      this.post("addressInterfaces/v1.0/getMemberAddress", {
        page: -1,
        page_size: -1
      }).then(res => {
        let arr = res.data;
        arr.forEach(el => {
          el.address = [];
          el.address.push(el.address_province);
          el.address.push(el.address_city)
          el.address.push(el.address_country)
          el.address = el.address.join("/")
          el.address += `    ${el.address_detailed}`
        })
        this.addressList = arr;
      })
    },

//获取客户发票列表
    getInvoices() {
      this.post("invoiceInterfaces/v1.0/getInvoices", {
        page: -1,
        page_size: -1
      }).then(res => {
        let arr = res.data;
        arr.forEach(el => {
          el.invoice_name = `${el.invoice_type == '1' ? "增值税普票" : "增值票专票"} ${el.invoice_name}`
        })
        this.invoiceList = arr;
      })
    },
// 服务类型.
    getServiceTypes() {
      this.post("serviceInterfaces/v1.0/getServiceTypes").then((res) => {
        this.serviceTypesList = res.data;
      });
    },
// 服务人员登记
    getServiceLevels() {
      this.post("serviceInterfaces/v1.0/getServiceLevels").then((res) => {
        this.serviceLevelsList = res.data;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.apply-for-service {
  .el-select, .el-date-editor {
    width: 100%;
  }

  .integral-input {

  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/serviceOrder/components/applyForService.vue